export const GLOBAL_SET_CURRENT_PERIOD = 'GLOBAL_SET_CURRENT_PERIOD';

export function setCurrentPeriod(period) {
  return {
    type: GLOBAL_SET_CURRENT_PERIOD,
    data: period,
  };
}
